(() => {
  const PLACEHOLDER = 'Učitavanje';

  const money = (cents) => {
    const value = (cents || 0) / 100;
    return new Intl.NumberFormat('sr-RS', {
      style: 'currency',
      currency: 'RSD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  let scheduled = false;
  let scheduledForce = false;
  let inFlight = false;
  let lastCartJson = null;
  let lastFetchAt = 0;

  async function getCart(force) {
    // throttle fetch da ne pravi 429; force preskace throttle posle izmene korpe
    const now = Date.now();
    if (!force && lastCartJson && now - lastFetchAt < 400) return lastCartJson;

    if (inFlight) return lastCartJson; // vrati sta ima, samo da ne spamujemo

    inFlight = true;
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      if (!res.ok) return lastCartJson;
      lastCartJson = await res.json();
      lastFetchAt = Date.now();
      return lastCartJson;
    } catch (e) {
      return lastCartJson;
    } finally {
      inFlight = false;
    }
  }

  function renderWidget(el, cart) {
    const threshold = parseInt(el.dataset.freeShippingThreshold || '0', 10);
    if (!threshold || !cart) return;

    const total = cart.total_price || 0; // cents
    const remaining = Math.max(0, threshold - total);
    const percent = Math.min(100, Math.round((total / threshold) * 100));

    const text = el.querySelector('.free-shipping-progress__text');
    const fill = el.querySelector('.free-shipping-progress__bar-fill');
    const bar = el.querySelector('.free-shipping-progress__bar');

    if (!text || !fill) return;

    if (remaining === 0) {
      text.textContent = "✅ Besplatna dostava je aktivna.";
      el.classList.add('free-shipping-progress--active');
      fill.style.width = '100%';
      if (bar) bar.setAttribute('aria-valuenow', '100');
    } else {
      text.textContent = `Dodajte još ${money(remaining)} za besplatnu dostavu.`;
      el.classList.remove('free-shipping-progress--active');
      fill.style.width = percent + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(percent));
    }
  }

  // Dawn zameni ceo .js-contents pa se widget vrati na "Učitavanje…".
  // Ako je ijedan vidljiv widget ostao na placeholderu, podaci nam fale.
  function anyWidgetStuck() {
    const widgets = document.querySelectorAll('.free-shipping-progress__text');
    for (const el of widgets) {
      if (el.textContent.indexOf(PLACEHOLDER) !== -1 && el.getClientRects().length) return true;
    }
    return false;
  }

  async function updateAll(force) {
    const widgets = document.querySelectorAll('.free-shipping-progress');
    if (!widgets.length) return;

    const cart = await getCart(force);
    if (!cart) {
      setTimeout(() => schedule(true), 400); // nikad ne ostavljaj "Učitavanje…"
      return;
    }

    widgets.forEach((el) => renderWidget(el, cart));

    if (anyWidgetStuck()) setTimeout(() => schedule(true), 400);
  }

  // Dvostruki rAF ceka Dawn re-render, ali u skrivenom tabu rAF NIKAD ne kucne
  // (document.hidden) pa bi widget zauvek ostao na "Ucitavanje...". Zato uvek
  // ide i setTimeout fallback, a prvi koji stigne pobedjuje.
  function nextTick(fn) {
    let done = false;
    const run = () => {
      if (done) return;
      done = true;
      fn();
    };
    if (!document.hidden) {
      requestAnimationFrame(() => requestAnimationFrame(run));
    }
    setTimeout(run, 250);
  }

  function schedule(force) {
    if (force) scheduledForce = true;
    if (scheduled) return;
    scheduled = true;

    nextTick(async () => {
      scheduled = false;
      const f = scheduledForce;
      scheduledForce = false;
      await updateAll(f);
    });
  }

  // Posle izmene korpe Dawn tek treba da zavrsi /cart/change.js + re-render sekcije,
  // pa jedan prolaz nije dovoljan - ponovi jos par puta sa svezim podacima.
  function bump() {
    schedule(true);
    setTimeout(() => schedule(true), 350);
    setTimeout(() => schedule(true), 1000);
    setTimeout(() => schedule(true), 2000);
  }

  // 1) start
  document.addEventListener('DOMContentLoaded', () => schedule(true));

  // 2) kad god Dawn re-renderuje drawer/cart, MutationObserver ce uhvatiti
  const mo = new MutationObserver(() => schedule(anyWidgetStuck()));
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 3) fallback: klikovi na qty +/- cesto menjaju cart
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    if (
      t.closest('quantity-input') ||
      t.closest('.quantity') ||
      t.closest('cart-remove-button') ||
      t.closest('product-form')
    ) {
      bump();
    }
  });

  // 4) i na page show/back
  window.addEventListener('pageshow', () => schedule(true));
})();
